const reportStatus = {
  failed: null,
  started: null,
  succeeded: null,
};

export default reportStatus;
